import { tableEnUSTranslations } from "../components/table/_lang/en-US";
import { editableFieldEnUSTranslations } from "../controls/editable-field/_lang/en-US";
import { fileEnUSTranslations } from "../controls/file/_lang/en-US";
import { taggedInputEnUSTranslations } from "../controls/tagged-input/_lang/en-US";
import { draftEnUSTranslations } from "../hooks/_lang/en-US";

export const rayaLucariaEnUS = {
  ...tableEnUSTranslations,
  ...draftEnUSTranslations,
  ...editableFieldEnUSTranslations,
  ...fileEnUSTranslations,
  ...taggedInputEnUSTranslations,
  apply: "Apply",
  cancel: "Cancel",
  close: "Close",
  dismiss: "Dismiss",
  saving: "Saving...",
  saved: "Saved",
  clear: "Clear",
  confirm: "Confirm",
  filter: "Filter",
  filterValue: "Filter value",
  expandMenu: "Expand menu",
  collapseMenu: "Collapse menu",
  openMenu: "Open menu",
  mainNavigation: "Main navigation",
  secondaryNavigation: "Secondary navigation",
  navigationMenu: "Navigation menu",
  skipToContent: "Skip to main content",
  aboutField: "About {{label}}",
  moreInformation: "More information",
  passcodeLegend: "Enter the {{count}}-character code",
  passcodeCharacter: "Character {{index}} of {{count}}",
  passcodeIncomplete: "Enter all {{count}} characters",
  reorderInstructions:
    "Press Space or Enter to pick up. Use the arrow keys to move. Press Space or Enter to drop, or Escape to cancel.",
  reorderPickedUp: "Picked up {{name}}. Position {{position}} of {{total}}.",
  reorderMoved: "{{name}} moved to position {{position}} of {{total}}.",
  reorderDropped: "{{name}} dropped at position {{position}} of {{total}}.",
  reorderCancelled:
    "Reorder cancelled. {{name}} returned to position {{position}} of {{total}}.",
  reorderSaving: "Saving the new order.",
  reorderSaved: "New order saved.",
  reorderSaveFailed:
    "Could not save the new order. {{name}} is at position {{position}} of {{total}}.",
  reorderRoleDescription: "draggable",
  reorderHandleColumn:
    "Reorder {{name}} column, position {{position}} of {{total}}",
  reorderHandleLineItem:
    "Reorder line item {{name}}, position {{position}} of {{total}}",
  reorderHandleDiscount:
    "Reorder discount {{name}}, position {{position}} of {{total}}",
  reorderLineItemFallback: "line item {{position}}",
  reorderDiscountFallback: "discount {{position}}",
  reorderHandleLineItemNameless:
    "Reorder line item, position {{position}} of {{total}}",
  reorderHandleDiscountNameless:
    "Reorder discount, position {{position}} of {{total}}",
  reorderRowActionsTip: "Actions",
  reorderRowActionsName:
    "Actions for {{name}}, position {{position}} of {{total}}",
  reorderMoveUp: "Move up",
  reorderMoveDown: "Move down",
};

export type RayaLucariaTranslationKey = keyof typeof rayaLucariaEnUS;
